module.exports = __webpack_public_path__ + "static/IMG_2808-68b401282bfe98f09e1378c5f7e130bc.jpg";